"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.convertNumericString = void 0;

var convertNumericString = function convertNumericString(value) {
  if (typeof value === 'number') {
    return value;
  }

  var strippedValue = value.replace(/[^0-9-.]/g, '');
  return strippedValue.indexOf('.') >= 0 ? parseFloat(strippedValue) : parseInt(strippedValue, 10);
};

exports.convertNumericString = convertNumericString;
var _default = convertNumericString;
exports.default = _default;